import {
  EditOutlined,
  EyeInvisibleOutlined
} from "@ant-design/icons";
import { Button, Card, Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

import { MaintenanceStatusTag } from "~/pages/materiaal/materialTags.jsx";
import { DocumentList } from "../documentList.jsx";
import { OrderDeleteButtons } from "~/pages/admin/dto/components/OrderDeleteButtons.jsx";

export const MatChapterCard = ({
  idx,
  loadingOrder,
  save_chapter_order,
  chapter,
  allChapters,
  documents,
  setOpenChapter,
  readOnly,
  materialID,
}) => {
  return (
    <Card
      size="small"
      className="Chapter"
      title={
        <p className="row" style={{ gap: 6 }}>
          <MaintenanceStatusTag maintenance_status={chapter.status} hideTag />
          {!readOnly && <span className="gray">#{chapter.order}</span>}{" "}
          {chapter.name}
          {!chapter.is_public && <EyeInvisibleOutlined />}
          {chapter.is_archived && (
            <Tag color="red" style={{ fontWeight: 400, fontSize: 11 }}>
              {$t("archief")}{" "}
            </Tag>
          )}
        </p>
      }
      style={{ margin: 4 }}
      extra={
        !readOnly && (
          <div className="row" style={{ gap: 6 }}>
            <OrderDeleteButtons
              loading={loadingOrder}
              task_index={idx}
              task={chapter}
              tasks={allChapters}
              saveTasks={(d) => save_chapter_order(d)}
              hasDelete={false}
            />
            <Button
              icon={<EditOutlined />}
              size="small"
              shape="circle"
              onClick={() => setOpenChapter(chapter)}
            />
          </div>
        )
      }
    >
      <DocumentList
        readOnly={readOnly}
        documents={documents}
        chapter={chapter}
        allChapters={allChapters}
        materialID={materialID}
      />
    </Card>
  );
};
